var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12025 13.0465C4.12025 13.8018 4.73825 14.4198 5.49357 14.4198H10.9868C11.7422 14.4198 12.3602 13.8018 12.3602 13.0465V4.8066H4.12025V13.0465ZM13.0468 2.74663H10.6435L9.95686 2.05997H6.52356L5.8369 2.74663H3.43359V4.11994H13.0468V2.74663Z",
    fill: "#ADADAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4798,
    height: 16.4798,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteThumb);
export default __webpack_public_path__ + "static/media/delete-thumb.7354279608a3700c5f0903941ce3a8ec.svg";
export { ForwardRef as ReactComponent };